var _circle, _path, _path2, _circle2, _path3, _path4, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFomo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FCD535"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 21C22.5 25.9706 18.4706 30 13.5 30C8.52944 30 4.5 25.9706 4.5 21C4.5 16.0294 8.52944 12 13.5 12C18.4706 12 22.5 16.0294 22.5 21Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 27.12C16.88 27.12 19.62 24.38 19.62 21C19.62 17.62 16.88 14.88 13.5 14.88C10.12 14.88 7.38 17.62 7.38 21C7.38 24.38 10.12 27.12 13.5 27.12ZM13.5 30C18.4706 30 22.5 25.9706 22.5 21C22.5 16.0294 18.4706 12 13.5 12C8.52944 12 4.5 16.0294 4.5 21C4.5 25.9706 8.52944 30 13.5 30Z",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5684,
    cy: 20.7955,
    r: 4.29545,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8555 21C42.8555 25.9706 38.826 30 33.8555 30C28.8849 30 24.8555 25.9706 24.8555 21C24.8555 16.0294 28.8849 12 33.8555 12C38.826 12 42.8555 16.0294 42.8555 21Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8555 27.12C37.2355 27.12 39.9755 24.38 39.9755 21C39.9755 17.62 37.2355 14.88 33.8555 14.88C30.4755 14.88 27.7355 17.62 27.7355 21C27.7355 24.38 30.4755 27.12 33.8555 27.12ZM33.8555 30C38.826 30 42.8555 25.9706 42.8555 21C42.8555 16.0294 38.826 12 33.8555 12C28.8849 12 24.8555 16.0294 24.8555 21C24.8555 25.9706 28.8849 30 33.8555 30Z",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.9239,
    cy: 20.7955,
    r: 4.29545,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFomo);
export default __webpack_public_path__ + "static/media/fomo.315fc0cf2f88de5a0e86a3831ecda7b3.svg";
export { ForwardRef as ReactComponent };